import script from "./DetailItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailItem.vue?vue&type=script&setup=true&lang=js"

import "./DetailItem.vue?vue&type=style&index=0&id=fd022c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd022c14"]])

export default __exports__